export default {
  GENERATE_OTP: "GENERATE_OTP",
  RESET_OTP: "RESET_OTP",
  LOGIN: "LOGIN",
  RESET_LOGIN: "RESET_LOGIN",
  OFFER_ACTION_DISCUSSION_CANDIDATE_COMMENT:
    "OFFER_ACTION_DISCUSSION_CANDIDATE_COMMENT",
  OFFER_ACTION_DISCUSSION_CANDIDATE_EDIT_COMMENT:
    "OFFER_ACTION_DISCUSSION_CANDIDATE_EDIT_COMMENT",
  OFFER_ACTION_DISCUSSION_GET_CANDIDATE_COMMENT:
    "OFFER_ACTION_DISCUSSION_GET_CANDIDATE_COMMENT",
  OFFERDOCUMENT_ACTION_DOCUMENTS_SENDREQUESTEDDOC:
    "OFFERDOCUMENT_ACTION_DOCUMENTS_SENDREQUESTEDDOC",
  OFFERDOCUMENT_ACTION_DOCUMENTS_FILEUPLOAD:
    "OFFERDOCUMENT_ACTION_DOCUMENTS_FILEUPLOAD",
  OFFERDOCUMENT_ACTION_DOCUMENTS_FILEUPLOAD_EDIT:
    "OFFERDOCUMENT_DOCUMENTS_FILEUPLOAD_EDIT",
  OFFEREDCANDIDATE_HELP_DESK: "OFFEREDCANDIDATE_HELP_DESK",

  /********** Agreements **********/
  SIGNING_LISTING: "SIGNING_LISTING",
  OFFERCANDIDATE_ACTION_PROFILE: "OFFERCANDIDATE_ACTION_PROFILE",
  QUALIFICATION_DETAIL_LIST: "QULIFICATION_DETAIL_LIST",
  COUNTRY_DETAIL_LIST: "COUNTRY_DETAIL_LIST",
  ADD_SKILLS_MASTER: "ADD_SKILLS_MASTER",
  SKILL_SET_LIST: "SKILL_SET_LIST",
  ADD_COMMENT: "ADD_COMMENT",
  COMMENT_LISTING: "COMMENT_LISTING",

  /********* job-opening **********/
  JOB_LISTING: "JOB_LISTING",
  JOB_DETAILS: "JOB_DETAILS",

  GET_CANDIDATE_CV_DETAILS: "GET_CANDIDATE_CV_DETAILS",

  /*************** Used for Loader ******************/
  START_LOADING: "START_LOADING",
  STOP_LOADING: "STOP_LOADING",

  MASTER_WORK_PREFERENCE_ACTION_DETAILS_LISTING:
    "MASTER_WORK_PREFERENCE_ACTION_DETAILS_LISTING",
};
